import { Link } from "@remix-run/react";
import { Notification as NotificationType } from "~/types";

type Props = Pick<
  NotificationType,
  "message" | "related_gremlin_streamer" | "related_trade_id" | "related_username"
>;

export default function Notification({
  message,
  related_gremlin_streamer,
  related_trade_id,
  related_username,
}: Props) {
  if (related_trade_id != null && related_trade_id != "") {
    return <Link to={`/trades/${related_trade_id}`}>{message}</Link>;
  } else if (related_username != null && related_username != "") {
    return (
      <Link
        to={`/user/${related_username}/collection?streamer=${related_gremlin_streamer}`}
      >
        {message}
      </Link>
    );
  } else {
    return <p>{message}</p>;
  }
}
